import React from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './breadCrumb.module.css';
import { Breadcrumbs } from '@mui/material';
import { RxCaretRight } from 'react-icons/rx';

function BreadCrumb({ data, className = '', isBack = false, backTitle, backIcon }) {
  const navigate = useNavigate();
  return (
    <div className={classes.head}>
      {isBack && (
        <div className={classes.back}>
          {backIcon}
          <span>{backTitle}</span>
        </div>
      )}
      <Breadcrumbs
        separator={<RxCaretRight size={20} />}
        className={[classes.breadcrumb, className].join(' ')}>
        {data?.map((item, key) => (
          <button
            className="btnWrapper"
            key={key?.toString()}
            onClick={(e) => {
              e.preventDefault();
              navigate(item?.path);
            }}>
            <p data-active={item?.active}>{item?.title}</p>
          </button>
        ))}
      </Breadcrumbs>
    </div>
  );
}

export default BreadCrumb;
